import * as React from 'react';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
// import DateRangePicker from '@mui/lab/DateRangePicker';
import { DateRange } from 'react-date-range';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import moment from 'moment'
import { Select, MenuItem, InputLabel, TextField, Stack } from '@mui/material';
import { getCitiesListing } from '../../Controllers/ScopeManagement';
import { getConceirgeListing } from '../../Controllers/Concierge';
import mainContext from '../../contexts/mainContext';

export default function Filter({ filterState, setFilterState, callFunction, userType }) {
    const context = React.useContext(mainContext);
    const { loginUserDetails } = context;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, setValue] = React.useState([null, null]);
    const [cities, setCities] = React.useState([]);
    const [conceirge, setConceirge] = React.useState([]);
    const [state, setState] = React.useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    React.useEffect(() => {
        async function getCity() {
            const res = await getCitiesListing();
            if (res.data.status === 200) {
                setCities(res.data.data)

            }
        }
        async function getConceirge() {
            const res = await getConceirgeListing();
            if (res.data.status === 200) {
                setConceirge(res.data.data.conceirge)
            }
        }

        getCity()
        getConceirge()

    }, [])

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusChange = (event) => {
        setFilterState({ ...filterState, fStatus: event.target.value });
    };

    const handlePaymentOnboardingChange = (event) => {
      setFilterState({ ...filterState, fPaymentOnboarding: event.target.value })
    };

    const handleApply = () => {
        callFunction(1);
        setAnchorEl(null);
    }

    const handleClear = () => {
        setFilterState({})
        setValue([null, null]);
        callFunction(1, false);
        setAnchorEl(null);
    }


  return (
    <>
      <Tooltip title="Filter">
        <FilterAltIcon
          className="pointer"
          style={{
            margin: "0 1rem 0 1rem",
          }}
          onClick={handleClick}
        />
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Container>
          <FormControl>
            <strong>By Status</strong>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue={filterState?.fStatus ? filterState?.fStatus : ""}
              onChange={handleStatusChange}
            >
              <FormControlLabel value="Sleeping" control={<Radio />} label="Sleeping" />
              <FormControlLabel value="Active" control={<Radio />} label="Active" />
              <FormControlLabel value="Inactive" control={<Radio />} label="Inactive" />
              <FormControlLabel value="" control={<Radio />} label="None" />
            </RadioGroup>
          </FormControl>

          <Divider />
          <br />

          {(userType === "babysitter" || userType === "housekeeper") && (
            <>
              <FormControl>
                <strong>By Payment Onboarding</strong>
                <RadioGroup
                  row
                  aria-labelledby="payment-onboarding-radio-buttons-group-label"
                  name="payment-onboarding-radio-buttons-group"
                  defaultValue={filterState?.fPaymentOnboarding ? filterState?.fPaymentOnboarding : ""}
                  onChange={handlePaymentOnboardingChange}
                >
                  <FormControlLabel value="stripe" control={<Radio />} label="Stripe" />
                  <FormControlLabel value="paypal" control={<Radio />} label="PayPal" />
                </RadioGroup>
              </FormControl>

              <Divider />
              <br />
            </>
          )}

          <div className="short_by">
            <strong>Sort By</strong>
            <div>
              <div>
                <Checkbox
                  checked={filterState.sName === true}
                  onChange={() => {
                    setFilterState({
                      ...filterState,
                      sName: true,
                      sAddedOn: false,
                    })
                  }}
                />
                Name
              </div>
              <div>
                <Checkbox
                  checked={filterState.sAddedOn === true}
                  onChange={() => {
                    setFilterState({
                      ...filterState,
                      sAddedOn: true,
                      sName: false,
                    })
                  }}
                />
                Registered on
              </div>
            </div>
          </div>

          <Divider />
          <br />

          {/*FROM AND TO DATE PICKER*/}
          <div className="date_div">
            <strong>By Date</strong>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField
                id="Date From"
                type={"date"}
                fullWidth
                inputProps={{ max: moment().format("YYYY-MM-DD") }}
                defaultValue={filterState.fStartDate && moment(filterState.fStartDate).format("YYYY-MM-DD")}
                label={filterState.fStartDate ? "Start date" : ""}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    fStartDate: moment(e.target.value).format("YYYY-MM-DD"),
                  })
                }}
              />
              <TextField
                id="Date To"
                type={"date"}
                inputProps={{
                  max: moment().format("YYYY-MM-DD"),
                  min: moment(filterState.fStartDate).format("YYYY-MM-DD"),
                }}
                fullWidth
                label={filterState.fStartDate ? "End date" : ""}
                InputLabelProps={{ shrink: true }}
                defaultValue={filterState.fEndDate && moment(filterState.fEndDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    fEndDate: moment(e.target.value).format("YYYY-MM-DD"),
                  })
                }}
              />
            </Stack>
          </div>
          <Divider />
          <br />

          <div className="country_select_div">
            <strong>By City</strong>
            <FormControl sx={{ width: "100%", color: "green" }}>
              <InputLabel id="city">City</InputLabel>
              <Select
                multiple
                className="city"
                id="city"
                label="City"
                defaultValue={
                  filterState
                    ? typeof filterState.fCity == "object"
                      ? filterState.fCity.length != 0
                        ? filterState.fCity
                        : []
                      : []
                    : []
                }
                onChange={(e) => {
                  setFilterState({ ...filterState, fCity: e.target.value })
                }}
              >
                {cities.map((data, index) => (
                  <MenuItem key={index} value={data.city}>
                    {data.city}
                  </MenuItem>
                ))}
                <MenuItem value={""}>None</MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* <Divider /><br />
                    {loginUserDetails.role !== "Concierge" && conceirge.length > 0 && <>
                        <div className='country_select_div'>
                            <strong >By Concierge</strong>
                            <FormControl sx={{ width: '100%', color: 'green' }}>
                                <InputLabel id="city">Concierge</InputLabel>
                                <Select
                                    className='conceirge'
                                    id='conceirge'
                                    label="Conceirge"
                                    defaultValue={filterState?.conceirgeId}
                                    onChange={(e) => { setFilterState({ ...filterState, conceirgeId: e.target.value }) }}
                                >
                                    {conceirge.map((data) => <MenuItem value={data._id}>{data.firstName + " " + data.lastName}</MenuItem>)}
                                    <MenuItem value={""}>None</MenuItem>
                                </Select>
                            </FormControl>

                        </div>
                        <Divider /><br />

                    </>} */}

          <Actions>
            <Button variant="contained" size="small" style={{ textTransform: "unset" }} onClick={handleApply}>
              Apply filter
            </Button>
            <Button variant="outlined" size="small" style={{ textTransform: "unset" }} onClick={handleClear}>
              Clear filter
            </Button>
          </Actions>
        </Container>
      </Menu>
    </>
  )
}

const Container = styled("div")`
    padding: 1rem;
    .my-2{
        margin-top: 1rem;
    }
    &>.short_by{
        display: flex;
        flex-direction: column;
        &>div{
            display: flex;
            column-gap: 1rem;
        }
    }
    &>.country_select_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
    &>.date_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
`

const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;
`
